/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as VerificarImport } from "./routes/verificar";
import { Route as ConviteImport } from "./routes/convite";
import { Route as AuthImport } from "./routes/auth";
import { Route as AuthenticatedImport } from "./routes/_authenticated";
import { Route as AuthenticatedIndexImport } from "./routes/_authenticated/index";
import { Route as ConviteTokenImport } from "./routes/convite/$token";
import { Route as AuthRegistrarImport } from "./routes/auth/registrar";
import { Route as AuthRecuperarSenhaImport } from "./routes/auth/recuperar-senha";
import { Route as AuthLoginImport } from "./routes/auth/login";
import { Route as AuthenticatedTutoriaisImport } from "./routes/_authenticated/tutoriais";
import { Route as AuthenticatedDashboardImport } from "./routes/_authenticated/dashboard";
import { Route as AuthenticatedWorkspacesIndexImport } from "./routes/_authenticated/workspaces/index";
import { Route as AuthenticatedOrganizacaoIndexImport } from "./routes/_authenticated/organizacao/index";
import { Route as AuthenticatedNotificacoesIndexImport } from "./routes/_authenticated/notificacoes/index";
import { Route as AuthenticatedWorkspacesCriarIndexImport } from "./routes/_authenticated/workspaces/criar/index";
import { Route as AuthenticatedWorkspacesWrkidIndexImport } from "./routes/_authenticated/workspaces/$wrk_id/index";
import { Route as AuthenticatedOrganizacaoFaturamentoIndexImport } from "./routes/_authenticated/organizacao/faturamento/index";
import { Route as AuthenticatedOrganizacaoDetalhesIndexImport } from "./routes/_authenticated/organizacao/detalhes/index";
import { Route as AuthenticatedOrganizacaoColaboradoresIndexImport } from "./routes/_authenticated/organizacao/colaboradores/index";
import { Route as AuthenticatedContaSegurancaIndexImport } from "./routes/_authenticated/conta/seguranca/index";
import { Route as AuthenticatedContaNotificacoesIndexImport } from "./routes/_authenticated/conta/notificacoes/index";
import { Route as AuthenticatedContaGeralIndexImport } from "./routes/_authenticated/conta/geral/index";
import { Route as AuthenticatedOrganizacaoFaturamentoMudarPlanoImport } from "./routes/_authenticated/organizacao/faturamento/mudar-plano";
import { Route as AuthenticatedContaGeralTrocarSenhaImport } from "./routes/_authenticated/conta/geral/trocar-senha";
import { Route as AuthenticatedWorkspacesWrkidFlowFlowidIndexImport } from "./routes/_authenticated/workspaces/$wrk_id/flow/$flow_id/index";
import { Route as AuthenticatedWorkspacesWrkidAprovacaoApvidIndexImport } from "./routes/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/index";
import { Route as AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexImport } from "./routes/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/index";

// Create/Update Routes

const VerificarRoute = VerificarImport.update({
  id: "/verificar",
  path: "/verificar",
  getParentRoute: () => rootRoute,
} as any);

const ConviteRoute = ConviteImport.update({
  id: "/convite",
  path: "/convite",
  getParentRoute: () => rootRoute,
} as any);

const AuthRoute = AuthImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedRoute = AuthenticatedImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const ConviteTokenRoute = ConviteTokenImport.update({
  id: "/$token",
  path: "/$token",
  getParentRoute: () => ConviteRoute,
} as any);

const AuthRegistrarRoute = AuthRegistrarImport.update({
  id: "/registrar",
  path: "/registrar",
  getParentRoute: () => AuthRoute,
} as any);

const AuthRecuperarSenhaRoute = AuthRecuperarSenhaImport.update({
  id: "/recuperar-senha",
  path: "/recuperar-senha",
  getParentRoute: () => AuthRoute,
} as any);

const AuthLoginRoute = AuthLoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRoute,
} as any);

const AuthenticatedTutoriaisRoute = AuthenticatedTutoriaisImport.update({
  id: "/tutoriais",
  path: "/tutoriais",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedWorkspacesIndexRoute = AuthenticatedWorkspacesIndexImport.update({
  id: "/workspaces/",
  path: "/workspaces/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedOrganizacaoIndexRoute = AuthenticatedOrganizacaoIndexImport.update({
  id: "/organizacao/",
  path: "/organizacao/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedNotificacoesIndexRoute = AuthenticatedNotificacoesIndexImport.update({
  id: "/notificacoes/",
  path: "/notificacoes/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedWorkspacesCriarIndexRoute = AuthenticatedWorkspacesCriarIndexImport.update({
  id: "/workspaces/criar/",
  path: "/workspaces/criar/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedWorkspacesWrkidIndexRoute = AuthenticatedWorkspacesWrkidIndexImport.update({
  id: "/workspaces/$wrk_id/",
  path: "/workspaces/$wrk_id/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedOrganizacaoFaturamentoIndexRoute =
  AuthenticatedOrganizacaoFaturamentoIndexImport.update({
    id: "/organizacao/faturamento/",
    path: "/organizacao/faturamento/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedOrganizacaoDetalhesIndexRoute =
  AuthenticatedOrganizacaoDetalhesIndexImport.update({
    id: "/organizacao/detalhes/",
    path: "/organizacao/detalhes/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedOrganizacaoColaboradoresIndexRoute =
  AuthenticatedOrganizacaoColaboradoresIndexImport.update({
    id: "/organizacao/colaboradores/",
    path: "/organizacao/colaboradores/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedContaSegurancaIndexRoute = AuthenticatedContaSegurancaIndexImport.update({
  id: "/conta/seguranca/",
  path: "/conta/seguranca/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedContaNotificacoesIndexRoute = AuthenticatedContaNotificacoesIndexImport.update({
  id: "/conta/notificacoes/",
  path: "/conta/notificacoes/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedContaGeralIndexRoute = AuthenticatedContaGeralIndexImport.update({
  id: "/conta/geral/",
  path: "/conta/geral/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute =
  AuthenticatedOrganizacaoFaturamentoMudarPlanoImport.update({
    id: "/organizacao/faturamento/mudar-plano",
    path: "/organizacao/faturamento/mudar-plano",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedContaGeralTrocarSenhaRoute = AuthenticatedContaGeralTrocarSenhaImport.update({
  id: "/conta/geral/trocar-senha",
  path: "/conta/geral/trocar-senha",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute =
  AuthenticatedWorkspacesWrkidFlowFlowidIndexImport.update({
    id: "/workspaces/$wrk_id/flow/$flow_id/",
    path: "/workspaces/$wrk_id/flow/$flow_id/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute =
  AuthenticatedWorkspacesWrkidAprovacaoApvidIndexImport.update({
    id: "/workspaces/$wrk_id/aprovacao/$apv_id/",
    path: "/workspaces/$wrk_id/aprovacao/$apv_id/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute =
  AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexImport.update({
    id: "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/",
    path: "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedImport;
      parentRoute: typeof rootRoute;
    };
    "/auth": {
      id: "/auth";
      path: "/auth";
      fullPath: "/auth";
      preLoaderRoute: typeof AuthImport;
      parentRoute: typeof rootRoute;
    };
    "/convite": {
      id: "/convite";
      path: "/convite";
      fullPath: "/convite";
      preLoaderRoute: typeof ConviteImport;
      parentRoute: typeof rootRoute;
    };
    "/verificar": {
      id: "/verificar";
      path: "/verificar";
      fullPath: "/verificar";
      preLoaderRoute: typeof VerificarImport;
      parentRoute: typeof rootRoute;
    };
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AuthenticatedDashboardImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/tutoriais": {
      id: "/_authenticated/tutoriais";
      path: "/tutoriais";
      fullPath: "/tutoriais";
      preLoaderRoute: typeof AuthenticatedTutoriaisImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/auth/login": {
      id: "/auth/login";
      path: "/login";
      fullPath: "/auth/login";
      preLoaderRoute: typeof AuthLoginImport;
      parentRoute: typeof AuthImport;
    };
    "/auth/recuperar-senha": {
      id: "/auth/recuperar-senha";
      path: "/recuperar-senha";
      fullPath: "/auth/recuperar-senha";
      preLoaderRoute: typeof AuthRecuperarSenhaImport;
      parentRoute: typeof AuthImport;
    };
    "/auth/registrar": {
      id: "/auth/registrar";
      path: "/registrar";
      fullPath: "/auth/registrar";
      preLoaderRoute: typeof AuthRegistrarImport;
      parentRoute: typeof AuthImport;
    };
    "/convite/$token": {
      id: "/convite/$token";
      path: "/$token";
      fullPath: "/convite/$token";
      preLoaderRoute: typeof ConviteTokenImport;
      parentRoute: typeof ConviteImport;
    };
    "/_authenticated/": {
      id: "/_authenticated/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/notificacoes/": {
      id: "/_authenticated/notificacoes/";
      path: "/notificacoes";
      fullPath: "/notificacoes";
      preLoaderRoute: typeof AuthenticatedNotificacoesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/organizacao/": {
      id: "/_authenticated/organizacao/";
      path: "/organizacao";
      fullPath: "/organizacao";
      preLoaderRoute: typeof AuthenticatedOrganizacaoIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/": {
      id: "/_authenticated/workspaces/";
      path: "/workspaces";
      fullPath: "/workspaces";
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/conta/geral/trocar-senha": {
      id: "/_authenticated/conta/geral/trocar-senha";
      path: "/conta/geral/trocar-senha";
      fullPath: "/conta/geral/trocar-senha";
      preLoaderRoute: typeof AuthenticatedContaGeralTrocarSenhaImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/organizacao/faturamento/mudar-plano": {
      id: "/_authenticated/organizacao/faturamento/mudar-plano";
      path: "/organizacao/faturamento/mudar-plano";
      fullPath: "/organizacao/faturamento/mudar-plano";
      preLoaderRoute: typeof AuthenticatedOrganizacaoFaturamentoMudarPlanoImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/conta/geral/": {
      id: "/_authenticated/conta/geral/";
      path: "/conta/geral";
      fullPath: "/conta/geral";
      preLoaderRoute: typeof AuthenticatedContaGeralIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/conta/notificacoes/": {
      id: "/_authenticated/conta/notificacoes/";
      path: "/conta/notificacoes";
      fullPath: "/conta/notificacoes";
      preLoaderRoute: typeof AuthenticatedContaNotificacoesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/conta/seguranca/": {
      id: "/_authenticated/conta/seguranca/";
      path: "/conta/seguranca";
      fullPath: "/conta/seguranca";
      preLoaderRoute: typeof AuthenticatedContaSegurancaIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/organizacao/colaboradores/": {
      id: "/_authenticated/organizacao/colaboradores/";
      path: "/organizacao/colaboradores";
      fullPath: "/organizacao/colaboradores";
      preLoaderRoute: typeof AuthenticatedOrganizacaoColaboradoresIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/organizacao/detalhes/": {
      id: "/_authenticated/organizacao/detalhes/";
      path: "/organizacao/detalhes";
      fullPath: "/organizacao/detalhes";
      preLoaderRoute: typeof AuthenticatedOrganizacaoDetalhesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/organizacao/faturamento/": {
      id: "/_authenticated/organizacao/faturamento/";
      path: "/organizacao/faturamento";
      fullPath: "/organizacao/faturamento";
      preLoaderRoute: typeof AuthenticatedOrganizacaoFaturamentoIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/$wrk_id/": {
      id: "/_authenticated/workspaces/$wrk_id/";
      path: "/workspaces/$wrk_id";
      fullPath: "/workspaces/$wrk_id";
      preLoaderRoute: typeof AuthenticatedWorkspacesWrkidIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/criar/": {
      id: "/_authenticated/workspaces/criar/";
      path: "/workspaces/criar";
      fullPath: "/workspaces/criar";
      preLoaderRoute: typeof AuthenticatedWorkspacesCriarIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/": {
      id: "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/";
      path: "/workspaces/$wrk_id/aprovacao/$apv_id";
      fullPath: "/workspaces/$wrk_id/aprovacao/$apv_id";
      preLoaderRoute: typeof AuthenticatedWorkspacesWrkidAprovacaoApvidIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/$wrk_id/flow/$flow_id/": {
      id: "/_authenticated/workspaces/$wrk_id/flow/$flow_id/";
      path: "/workspaces/$wrk_id/flow/$flow_id";
      fullPath: "/workspaces/$wrk_id/flow/$flow_id";
      preLoaderRoute: typeof AuthenticatedWorkspacesWrkidFlowFlowidIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/": {
      id: "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/";
      path: "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes";
      fullPath: "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes";
      preLoaderRoute: typeof AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedTutoriaisRoute: typeof AuthenticatedTutoriaisRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedNotificacoesIndexRoute: typeof AuthenticatedNotificacoesIndexRoute;
  AuthenticatedOrganizacaoIndexRoute: typeof AuthenticatedOrganizacaoIndexRoute;
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute;
  AuthenticatedContaGeralTrocarSenhaRoute: typeof AuthenticatedContaGeralTrocarSenhaRoute;
  AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute: typeof AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute;
  AuthenticatedContaGeralIndexRoute: typeof AuthenticatedContaGeralIndexRoute;
  AuthenticatedContaNotificacoesIndexRoute: typeof AuthenticatedContaNotificacoesIndexRoute;
  AuthenticatedContaSegurancaIndexRoute: typeof AuthenticatedContaSegurancaIndexRoute;
  AuthenticatedOrganizacaoColaboradoresIndexRoute: typeof AuthenticatedOrganizacaoColaboradoresIndexRoute;
  AuthenticatedOrganizacaoDetalhesIndexRoute: typeof AuthenticatedOrganizacaoDetalhesIndexRoute;
  AuthenticatedOrganizacaoFaturamentoIndexRoute: typeof AuthenticatedOrganizacaoFaturamentoIndexRoute;
  AuthenticatedWorkspacesWrkidIndexRoute: typeof AuthenticatedWorkspacesWrkidIndexRoute;
  AuthenticatedWorkspacesCriarIndexRoute: typeof AuthenticatedWorkspacesCriarIndexRoute;
  AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute: typeof AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute;
  AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute: typeof AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute;
  AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute: typeof AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedTutoriaisRoute: AuthenticatedTutoriaisRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedNotificacoesIndexRoute: AuthenticatedNotificacoesIndexRoute,
  AuthenticatedOrganizacaoIndexRoute: AuthenticatedOrganizacaoIndexRoute,
  AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  AuthenticatedContaGeralTrocarSenhaRoute: AuthenticatedContaGeralTrocarSenhaRoute,
  AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute:
    AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute,
  AuthenticatedContaGeralIndexRoute: AuthenticatedContaGeralIndexRoute,
  AuthenticatedContaNotificacoesIndexRoute: AuthenticatedContaNotificacoesIndexRoute,
  AuthenticatedContaSegurancaIndexRoute: AuthenticatedContaSegurancaIndexRoute,
  AuthenticatedOrganizacaoColaboradoresIndexRoute: AuthenticatedOrganizacaoColaboradoresIndexRoute,
  AuthenticatedOrganizacaoDetalhesIndexRoute: AuthenticatedOrganizacaoDetalhesIndexRoute,
  AuthenticatedOrganizacaoFaturamentoIndexRoute: AuthenticatedOrganizacaoFaturamentoIndexRoute,
  AuthenticatedWorkspacesWrkidIndexRoute: AuthenticatedWorkspacesWrkidIndexRoute,
  AuthenticatedWorkspacesCriarIndexRoute: AuthenticatedWorkspacesCriarIndexRoute,
  AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute:
    AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute,
  AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute:
    AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute,
  AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute:
    AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute;
  AuthRecuperarSenhaRoute: typeof AuthRecuperarSenhaRoute;
  AuthRegistrarRoute: typeof AuthRegistrarRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRecuperarSenhaRoute: AuthRecuperarSenhaRoute,
  AuthRegistrarRoute: AuthRegistrarRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface ConviteRouteChildren {
  ConviteTokenRoute: typeof ConviteTokenRoute;
}

const ConviteRouteChildren: ConviteRouteChildren = {
  ConviteTokenRoute: ConviteTokenRoute,
};

const ConviteRouteWithChildren = ConviteRoute._addFileChildren(ConviteRouteChildren);

export interface FileRoutesByFullPath {
  "": typeof AuthenticatedRouteWithChildren;
  "/auth": typeof AuthRouteWithChildren;
  "/convite": typeof ConviteRouteWithChildren;
  "/verificar": typeof VerificarRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/tutoriais": typeof AuthenticatedTutoriaisRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/recuperar-senha": typeof AuthRecuperarSenhaRoute;
  "/auth/registrar": typeof AuthRegistrarRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/notificacoes": typeof AuthenticatedNotificacoesIndexRoute;
  "/organizacao": typeof AuthenticatedOrganizacaoIndexRoute;
  "/workspaces": typeof AuthenticatedWorkspacesIndexRoute;
  "/conta/geral/trocar-senha": typeof AuthenticatedContaGeralTrocarSenhaRoute;
  "/organizacao/faturamento/mudar-plano": typeof AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute;
  "/conta/geral": typeof AuthenticatedContaGeralIndexRoute;
  "/conta/notificacoes": typeof AuthenticatedContaNotificacoesIndexRoute;
  "/conta/seguranca": typeof AuthenticatedContaSegurancaIndexRoute;
  "/organizacao/colaboradores": typeof AuthenticatedOrganizacaoColaboradoresIndexRoute;
  "/organizacao/detalhes": typeof AuthenticatedOrganizacaoDetalhesIndexRoute;
  "/organizacao/faturamento": typeof AuthenticatedOrganizacaoFaturamentoIndexRoute;
  "/workspaces/$wrk_id": typeof AuthenticatedWorkspacesWrkidIndexRoute;
  "/workspaces/criar": typeof AuthenticatedWorkspacesCriarIndexRoute;
  "/workspaces/$wrk_id/aprovacao/$apv_id": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute;
  "/workspaces/$wrk_id/flow/$flow_id": typeof AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute;
  "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute;
}

export interface FileRoutesByTo {
  "/auth": typeof AuthRouteWithChildren;
  "/convite": typeof ConviteRouteWithChildren;
  "/verificar": typeof VerificarRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/tutoriais": typeof AuthenticatedTutoriaisRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/recuperar-senha": typeof AuthRecuperarSenhaRoute;
  "/auth/registrar": typeof AuthRegistrarRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/notificacoes": typeof AuthenticatedNotificacoesIndexRoute;
  "/organizacao": typeof AuthenticatedOrganizacaoIndexRoute;
  "/workspaces": typeof AuthenticatedWorkspacesIndexRoute;
  "/conta/geral/trocar-senha": typeof AuthenticatedContaGeralTrocarSenhaRoute;
  "/organizacao/faturamento/mudar-plano": typeof AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute;
  "/conta/geral": typeof AuthenticatedContaGeralIndexRoute;
  "/conta/notificacoes": typeof AuthenticatedContaNotificacoesIndexRoute;
  "/conta/seguranca": typeof AuthenticatedContaSegurancaIndexRoute;
  "/organizacao/colaboradores": typeof AuthenticatedOrganizacaoColaboradoresIndexRoute;
  "/organizacao/detalhes": typeof AuthenticatedOrganizacaoDetalhesIndexRoute;
  "/organizacao/faturamento": typeof AuthenticatedOrganizacaoFaturamentoIndexRoute;
  "/workspaces/$wrk_id": typeof AuthenticatedWorkspacesWrkidIndexRoute;
  "/workspaces/criar": typeof AuthenticatedWorkspacesCriarIndexRoute;
  "/workspaces/$wrk_id/aprovacao/$apv_id": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute;
  "/workspaces/$wrk_id/flow/$flow_id": typeof AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute;
  "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/auth": typeof AuthRouteWithChildren;
  "/convite": typeof ConviteRouteWithChildren;
  "/verificar": typeof VerificarRoute;
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute;
  "/_authenticated/tutoriais": typeof AuthenticatedTutoriaisRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/recuperar-senha": typeof AuthRecuperarSenhaRoute;
  "/auth/registrar": typeof AuthRegistrarRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/_authenticated/": typeof AuthenticatedIndexRoute;
  "/_authenticated/notificacoes/": typeof AuthenticatedNotificacoesIndexRoute;
  "/_authenticated/organizacao/": typeof AuthenticatedOrganizacaoIndexRoute;
  "/_authenticated/workspaces/": typeof AuthenticatedWorkspacesIndexRoute;
  "/_authenticated/conta/geral/trocar-senha": typeof AuthenticatedContaGeralTrocarSenhaRoute;
  "/_authenticated/organizacao/faturamento/mudar-plano": typeof AuthenticatedOrganizacaoFaturamentoMudarPlanoRoute;
  "/_authenticated/conta/geral/": typeof AuthenticatedContaGeralIndexRoute;
  "/_authenticated/conta/notificacoes/": typeof AuthenticatedContaNotificacoesIndexRoute;
  "/_authenticated/conta/seguranca/": typeof AuthenticatedContaSegurancaIndexRoute;
  "/_authenticated/organizacao/colaboradores/": typeof AuthenticatedOrganizacaoColaboradoresIndexRoute;
  "/_authenticated/organizacao/detalhes/": typeof AuthenticatedOrganizacaoDetalhesIndexRoute;
  "/_authenticated/organizacao/faturamento/": typeof AuthenticatedOrganizacaoFaturamentoIndexRoute;
  "/_authenticated/workspaces/$wrk_id/": typeof AuthenticatedWorkspacesWrkidIndexRoute;
  "/_authenticated/workspaces/criar/": typeof AuthenticatedWorkspacesCriarIndexRoute;
  "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidIndexRoute;
  "/_authenticated/workspaces/$wrk_id/flow/$flow_id/": typeof AuthenticatedWorkspacesWrkidFlowFlowidIndexRoute;
  "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/": typeof AuthenticatedWorkspacesWrkidAprovacaoApvidDetalhesIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ""
    | "/auth"
    | "/convite"
    | "/verificar"
    | "/dashboard"
    | "/tutoriais"
    | "/auth/login"
    | "/auth/recuperar-senha"
    | "/auth/registrar"
    | "/convite/$token"
    | "/"
    | "/notificacoes"
    | "/organizacao"
    | "/workspaces"
    | "/conta/geral/trocar-senha"
    | "/organizacao/faturamento/mudar-plano"
    | "/conta/geral"
    | "/conta/notificacoes"
    | "/conta/seguranca"
    | "/organizacao/colaboradores"
    | "/organizacao/detalhes"
    | "/organizacao/faturamento"
    | "/workspaces/$wrk_id"
    | "/workspaces/criar"
    | "/workspaces/$wrk_id/aprovacao/$apv_id"
    | "/workspaces/$wrk_id/flow/$flow_id"
    | "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/auth"
    | "/convite"
    | "/verificar"
    | "/dashboard"
    | "/tutoriais"
    | "/auth/login"
    | "/auth/recuperar-senha"
    | "/auth/registrar"
    | "/convite/$token"
    | "/"
    | "/notificacoes"
    | "/organizacao"
    | "/workspaces"
    | "/conta/geral/trocar-senha"
    | "/organizacao/faturamento/mudar-plano"
    | "/conta/geral"
    | "/conta/notificacoes"
    | "/conta/seguranca"
    | "/organizacao/colaboradores"
    | "/organizacao/detalhes"
    | "/organizacao/faturamento"
    | "/workspaces/$wrk_id"
    | "/workspaces/criar"
    | "/workspaces/$wrk_id/aprovacao/$apv_id"
    | "/workspaces/$wrk_id/flow/$flow_id"
    | "/workspaces/$wrk_id/aprovacao/$apv_id/detalhes";
  id:
    | "__root__"
    | "/_authenticated"
    | "/auth"
    | "/convite"
    | "/verificar"
    | "/_authenticated/dashboard"
    | "/_authenticated/tutoriais"
    | "/auth/login"
    | "/auth/recuperar-senha"
    | "/auth/registrar"
    | "/convite/$token"
    | "/_authenticated/"
    | "/_authenticated/notificacoes/"
    | "/_authenticated/organizacao/"
    | "/_authenticated/workspaces/"
    | "/_authenticated/conta/geral/trocar-senha"
    | "/_authenticated/organizacao/faturamento/mudar-plano"
    | "/_authenticated/conta/geral/"
    | "/_authenticated/conta/notificacoes/"
    | "/_authenticated/conta/seguranca/"
    | "/_authenticated/organizacao/colaboradores/"
    | "/_authenticated/organizacao/detalhes/"
    | "/_authenticated/organizacao/faturamento/"
    | "/_authenticated/workspaces/$wrk_id/"
    | "/_authenticated/workspaces/criar/"
    | "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/"
    | "/_authenticated/workspaces/$wrk_id/flow/$flow_id/"
    | "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
  ConviteRoute: typeof ConviteRouteWithChildren;
  VerificarRoute: typeof VerificarRoute;
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ConviteRoute: ConviteRouteWithChildren,
  VerificarRoute: VerificarRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/auth",
        "/convite",
        "/verificar"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/dashboard",
        "/_authenticated/tutoriais",
        "/_authenticated/",
        "/_authenticated/notificacoes/",
        "/_authenticated/organizacao/",
        "/_authenticated/workspaces/",
        "/_authenticated/conta/geral/trocar-senha",
        "/_authenticated/organizacao/faturamento/mudar-plano",
        "/_authenticated/conta/geral/",
        "/_authenticated/conta/notificacoes/",
        "/_authenticated/conta/seguranca/",
        "/_authenticated/organizacao/colaboradores/",
        "/_authenticated/organizacao/detalhes/",
        "/_authenticated/organizacao/faturamento/",
        "/_authenticated/workspaces/$wrk_id/",
        "/_authenticated/workspaces/criar/",
        "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/",
        "/_authenticated/workspaces/$wrk_id/flow/$flow_id/",
        "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/"
      ]
    },
    "/auth": {
      "filePath": "auth.tsx",
      "children": [
        "/auth/login",
        "/auth/recuperar-senha",
        "/auth/registrar"
      ]
    },
    "/convite": {
      "filePath": "convite.tsx",
      "children": [
        "/convite/$token"
      ]
    },
    "/verificar": {
      "filePath": "verificar.tsx"
    },
    "/_authenticated/dashboard": {
      "filePath": "_authenticated/dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/tutoriais": {
      "filePath": "_authenticated/tutoriais.tsx",
      "parent": "/_authenticated"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx",
      "parent": "/auth"
    },
    "/auth/recuperar-senha": {
      "filePath": "auth/recuperar-senha.tsx",
      "parent": "/auth"
    },
    "/auth/registrar": {
      "filePath": "auth/registrar.tsx",
      "parent": "/auth"
    },
    "/convite/$token": {
      "filePath": "convite/$token.tsx",
      "parent": "/convite"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/notificacoes/": {
      "filePath": "_authenticated/notificacoes/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organizacao/": {
      "filePath": "_authenticated/organizacao/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/": {
      "filePath": "_authenticated/workspaces/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/conta/geral/trocar-senha": {
      "filePath": "_authenticated/conta/geral/trocar-senha.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organizacao/faturamento/mudar-plano": {
      "filePath": "_authenticated/organizacao/faturamento/mudar-plano.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/conta/geral/": {
      "filePath": "_authenticated/conta/geral/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/conta/notificacoes/": {
      "filePath": "_authenticated/conta/notificacoes/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/conta/seguranca/": {
      "filePath": "_authenticated/conta/seguranca/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organizacao/colaboradores/": {
      "filePath": "_authenticated/organizacao/colaboradores/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organizacao/detalhes/": {
      "filePath": "_authenticated/organizacao/detalhes/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organizacao/faturamento/": {
      "filePath": "_authenticated/organizacao/faturamento/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/$wrk_id/": {
      "filePath": "_authenticated/workspaces/$wrk_id/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/criar/": {
      "filePath": "_authenticated/workspaces/criar/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/": {
      "filePath": "_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/$wrk_id/flow/$flow_id/": {
      "filePath": "_authenticated/workspaces/$wrk_id/flow/$flow_id/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/": {
      "filePath": "_authenticated/workspaces/$wrk_id/aprovacao/$apv_id/detalhes/index.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
